var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderCardDelivery2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 11.7497C1.58203 7.10128 5.3503 3.33301 9.9987 3.33301C14.6471 3.33301 18.4154 7.10128 18.4154 11.7497C18.4154 14.076 17.4724 16.1811 15.946 17.7053H4.0514C2.52496 16.1811 1.58203 14.076 1.58203 11.7497Z",
    stroke: "#717171",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.58301H9.7106C8.52713 7.58301 7.57028 8.61745 7.87338 9.76144C8.87674 13.5484 11.6207 14.7671 18.3333 15.083",
    stroke: "#717171",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderCardDelivery2);
export default __webpack_public_path__ + "static/media/iconOrderCardDelivery2.39b07f93c57f97e5ebd0adc23870d191.svg";
export { ForwardRef as ReactComponent };